<script setup lang="ts">
import { watch } from 'vue'
import { currentUserAndPermissions } from '@/app'
import { useTheme } from 'vuetify'
import useTracker from '@/composables/useTracker'

type BeaconOptions = Record<string, unknown>
type BeaconData = Record<string, unknown>

declare global {
  interface Window {
    Beacon?: {
      (method: string, options?: BeaconOptions | string, data?: BeaconData): void
      readyQueue: Array<{ method: string; options?: BeaconOptions | string; data?: BeaconData }>
    }
    attachEvent?: (event: string, handler: () => void) => void
  }
}

;(function (e: Window, t: Document, n: Window['Beacon'] | undefined) {
  function a() {
    var script = t.getElementsByTagName('script')[0]
    if (!script || !script.parentNode) {
      return
    }
    var n = t.createElement('script')
    n.type = 'text/javascript'
    n.async = true
    n.src = 'https://beacon-v2.helpscout.net'
    script.parentNode.insertBefore(n, script)
  }
  const beaconFn = function (t: string, n?: BeaconOptions | string, a?: BeaconData) {
    if (e.Beacon) {
      e.Beacon.readyQueue.push({ method: t, options: n, data: a })
    }
  } as Window['Beacon']
  e.Beacon = n = beaconFn
  if (n) {
    n.readyQueue = []
  }
  if ('complete' === t.readyState) {
    a()
    return
  }
  if (e.attachEvent) {
    e.attachEvent('onload', a)
  } else {
    e.addEventListener('load', a, false)
  }
})(window, document, window.Beacon)
window.Beacon?.('init', '5f666d96-e0eb-4237-be0b-936806082b71')

const theme = useTheme()

watch(currentUserAndPermissions, (v) => {
  if (!v) {
    return
  }

  window.Beacon?.('identify', {
    name: `${v.user.firstname} ${v.user.lastname}`,
    email: v.user.email,
    company: v.organization?.name,
    'organization-id': v.organization?.id,
    'user-id': v.user.id,
  })
})

const { trackerSessionUrl } = useTracker()
const openBeacon = () => {
  window.Beacon?.('session-data', {
    'Tracker Session URL': trackerSessionUrl.value,
    'Console Release': import.meta.env.VITE_GIT_SHA,
  })
  window.Beacon?.('config', {
    enableSounds: false,
    color: theme.themes.value.customLightTheme.colors.primary,
  })
  window.Beacon?.('toggle')
}
</script>

<template>
  <v-btn id="helpActivator" icon="help" variant="text" density="compact" @click="openBeacon" />
</template>

<style lang="scss">
#helpActivator {
  position: fixed;
  right: 0.1em;
  bottom: 0.1em;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}
</style>
